import { createQueryActions } from 'helpers/store/createQueryActions';

export const fetchService = createQueryActions('fetchService');

export const updateService = createQueryActions('updateService');
